import dayjs from "dayjs";
import "dayjs/locale/fr";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";

// Replaces dayjs-nuxt (unmaintained): configures dayjs directly with the plugins/locale we need.
export default defineNuxtPlugin(() => {
	dayjs.extend(updateLocale);
	dayjs.extend(relativeTime);
	dayjs.extend(utc);
	dayjs.extend(timezone);
	dayjs.extend(localizedFormat);

	dayjs.tz.setDefault("Europe/Luxembourg");
	dayjs.locale("fr");

	return {
		provide: {
			dayjs,
		},
	};
});
